import { select, call, put, takeLatest, cancelled } from 'typed-redux-saga';
import * as SearchActions from '../actions/search';
import * as selectors from '../selectors';
import { sendSearchResultsEvent } from './analytics';
import { searchArticles, SEARCH_PAGE_SIZE } from '../api/article';
import { getLanguageId } from '../utils/globals';
export function* requestSearch(action) {
    const { query, page } = action.payload;
    const offset = (action.payload.page - 1) * SEARCH_PAGE_SIZE;
    const fetchingStatus = yield* select(selectors.searchFetchingStatus, query, page);
    const shouldFetch = fetchingStatus === 'not-started';
    if (!shouldFetch)
        return;
    // const controller = new AbortController();
    try {
        yield* put(SearchActions.Actions.searchFetchStarted({ query, page }));
        const languageId = yield* call(getLanguageId);
        const data = yield* call(searchArticles, {
            term: query,
            languageId,
            offset,
            // controller,
        });
        yield* put(SearchActions.Actions.searchSuccess({ ...data, searchedTerm: query }));
        yield* call(sendSearchResultsEvent, query, page);
    }
    catch (error) {
        yield* put(SearchActions.Actions.searchFail());
    }
    finally {
        if (yield* cancelled()) {
            // controller.abort();
            yield* put(SearchActions.Actions.searchCancel());
        }
    }
}
// This watches for when we want to call the settings api and only allows the latest.
export function* watchSearchRequest() {
    yield* takeLatest(SearchActions.ActionTypes.SEARCH_REQUEST, requestSearch);
}
//# sourceMappingURL=search.js.map